import { Link } from "@remix-run/react";
import parse from "html-react-parser";

import { useLocalizedPath } from "~/helpers/navigationHelper";
import common from "~/i18n/common";
import { useT } from "~/i18n/useT";

import "./ErrorPage.scss";

type Props = {
  /** Rendered large above the title. Omitted for non-HTTP failures. */
  status?: number | string;
  title: string;
  /** Trusted HTML from our own i18n files. */
  description: string;
};

export default function ErrorPage({ status, title, description }: Props) {
  const t = useT(common);
  const localize = useLocalizedPath();

  return (
    <main className="ss-error">
      <div
        className="ss-glow ss-glow--blue ss-error__glow"
        aria-hidden="true"
      />
      <div className="ss-error__inner">
        {status ? (
          <p className="ss-error__status" aria-hidden="true">
            {status}
          </p>
        ) : null}
        {/* Some titles carry a <br> from the i18n files. */}
        <h1 className="ss-error__title">{parse(title)}</h1>
        <div className="ss-error__body">{parse(description)}</div>
        <Link to={localize("/")} className="ss-btn ss-btn--invert">
          {t.a11y.home}
        </Link>
      </div>
    </main>
  );
}
